export const LEGACY_ADMIN_MAIL = 'admin@bd-kol.com'
export const LEGACY_SUPER_MAIL = 'super@bd-kol.com'
export const LEGACY_USER_MAIL = 'user@bd-kol.com'

export const ADMIN_MAIL = 'administrator@bd-kol.com'
export const USER_MAIL = 'standard@bd-kol.com'

export const isUserAdmin = email => {
  return (
    email === ADMIN_MAIL ||
    email === LEGACY_ADMIN_MAIL ||
    email === LEGACY_SUPER_MAIL
  )
}
